import { isPlatformBrowser } from '@angular/common'
import { Inject, Injectable, PLATFORM_ID } from '@angular/core'
import { createStore, withProps } from '@ngneat/elf'
import { NzNotificationService } from 'ng-zorro-antd/notification'
import { map, Observable } from 'rxjs'
import { LoaderService } from './loader.service'

interface AppState {
  isLoading: boolean
  isBrowser: boolean
  channel: string
  template: string
}

@Injectable({
  providedIn: 'root',
})
export class AppService {
  appStore$ = createStore(
    { name: 'app' },
    withProps<AppState>({
      isLoading: false,
      isBrowser: false,
      channel: 'K7',
      template: 'k7-game-v1',
    })
  )

  public isLoading$: Observable<boolean> = this.appStore$.pipe(
    map((store) => store.isLoading)
  )

  public isBrowser$: Observable<boolean> = this.appStore$.pipe(
    map((store) => store.isBrowser)
  )

  private loaderVisible = false
  private readonly minLoaderTime = 1000
  private readonly delayBeforeShowing = 200

  constructor(
    private notification: NzNotificationService,
    private loaderService: LoaderService,
    @Inject(PLATFORM_ID) private platformId: string
  ) {
    // Subscribe to LoaderService's isLoading$ to update the app's loading state
    this.loaderService.isLoading$.subscribe((isLoading) => {
      if (isLoading) {
        this.showProgress()
      } else {
        this.hideProgress()
      }
    })

    this.appStore$.update((state) => {
      return {
        ...state,
        isBrowser: isPlatformBrowser(this.platformId),
      }
    })
  }

  /**
   * Sets the isLoading state to true.
   */
  showProgress(): void {
    this.appStore$.update((state) => ({
      ...state,
      isLoading: true,
    }))
  }

  /**
   * Sets the isLoading state to false.
   */
  hideProgress(): void {
    this.appStore$.update((state) => ({
      ...state,
      isLoading: false,
    }))
  }
}
